import { get } from "lodash";
import { onError, onFinish, onStart } from "../../httpService";
import stateModifier from "../../utils/stateModifier";
import {
  PASSCODE_SUBMIT,
  RECOVERY_PASSCODE_SUBMIT,
  RESEND_PASSWORD_RECOVERY_CODE
} from "../VerifyPasscode/constants";

import {
  GET_FACTORS,
  GET_QUESTION_STATUS,
  SESSION_EXPIRED,
  SIGN_IN,
  SKIP_FACTORS,
  ENC_DATA_SIGN_IN
} from "./constants";
import { UPDATE_FACTOR } from "../UpdateContact/constants";
import { CHANGE_PASSWORD } from "../ChangePassword/constants";
import { SET_SECURITY_QUESTION } from "../SetupSecurityQuestion/constants";
import { SUBMIT_ANSWER } from "../VerifySecurityQuestion/constants";
import { FORGOT_PASSWORD } from "../ForgotPassword/constants";
import { VERIFY_TOKEN } from "../TokenVerification/constants";
import { RESET_PASSWORD } from "../CreateNewPassword/constants";
import { oktaErrorMessage } from "../../utils/messageExtractor";
import { MFA_VERIFY_FACTOR } from "../VerifyMfaFactor/constants";
import { REMEMBER_DEVICE } from "../VerifyMfaFactor/constants";
export const initialState = {
  isAuthNCompleted: false,
  isAuthZCompleted: false,
  errorMessage: "",
  isLoading: false,
  credential: {},
  factors: [],
  factorStatus: "",
  rememberDevice: false,
  isPasswordExpired: false
};

const getEffectiveFactors = (storeFactors, factor) => {
  let toRemove = factor.factorType;
  let existing = storeFactors.filter((f) => f.factorType !== toRemove);
  return [...existing, factor];
};

const actionMap = new Map();
actionMap.set(SIGN_IN, (state, action) => {
  return {
    ...state,
    credential: action.data
  };
});

actionMap.set(onStart(SIGN_IN), (state, action) => {
  return {
    ...state,
    isLoading: true
  };
});
actionMap.set(onFinish(SIGN_IN), (state, action) => {
  let result = {
    ...state,
    isLoading: false,
    authnResponse: action.data,
    isAuthZCompleted: isAuthSuccess(action), // TODO: derive for other status in 200
    errorMessage: oktaErrorMessage(action),
    xCdkRequestId: getXOktaRequestId(action),
    isPasswordExpired: action.data.status === "PASSWORD_EXPIRED"
  };
  console.log(`result : ${result.isPasswordExpired}`);
  return result;
});

actionMap.set(onFinish(MFA_VERIFY_FACTOR), (state, action) => {
  if (
    !(
      action.data &&
      action.data._embedded.user.profile.login &&
      state.rememberDevice
    )
  ) {
    localStorage.removeItem(
      `device-${action.data._embedded.user.profile.login}`
    );
  }
  return {
    ...state,
    authnResponse: action.data,
    isAuthZCompleted: isAuthSuccess(action) // TODO: derive for other status in 200
  };
});

actionMap.set(onError(SIGN_IN), (state, action) => ({
  ...state,
  isLoading: false,
  isError: true,
  errorMessage: oktaErrorMessage(action)
}));

actionMap.set(ENC_DATA_SIGN_IN, (state, action) => {
  return {
    ...state,
    credential: action.data
  };
});

actionMap.set(onFinish(ENC_DATA_SIGN_IN), (state, action) => ({
  ...state,
  isLoading: false,
  authnResponse: action.data,
  isAuthZCompleted: isAuthSuccess(action), // TODO: derive for other status in 200
  errorMessage: oktaErrorMessage(action),
  xCdkRequestId: getXOktaRequestId(action)
}));
actionMap.set(onError(ENC_DATA_SIGN_IN), (state, action) => ({
  ...state,
  isLoading: false,
  isError: true,
  errorMessage: oktaErrorMessage(action)
}));
actionMap.set(onStart(CHANGE_PASSWORD), (state, action) => ({
  ...state,
  credential: {
    password: action.data.oldPassword,
    newPassword: action.data.newPassword
  }
}));

actionMap.set(onFinish(CHANGE_PASSWORD), (state, action) => ({
  ...state,
  isLoading: false,
  authnResponse: action.data,
  isAuthZCompleted: isAuthSuccess(action), // TODO: derive for other status in 200
  errorMessage: oktaErrorMessage(action),
  xCdkRequestId: getXOktaRequestId(action)
}));

actionMap.set(onError(CHANGE_PASSWORD), (state, action) => ({
  ...state,
  isLoading: false,
  isError: true,
  errorMessage: oktaErrorMessage(action)
}));

actionMap.set(onFinish(UPDATE_FACTOR), (state, action) => ({
  ...state,
  factors: [action.data],
  isPasswordExpired: false
  // factorStatus: getFactorStatus([action.data]),
}));

actionMap.set(onStart(GET_FACTORS), (state, action) => ({
  ...state,
  isLoading: true,
  isError: false

  // factors: action.data,
  // factorStatus: getFactorStatus(action.data),
}));

actionMap.set(onFinish(GET_FACTORS), (state, action) => ({
  ...state,
  isLoading: false,
  isError: false,
  factors: action.data
  // factorStatus: getFactorStatus(action.data),
}));

actionMap.set(onError(GET_FACTORS), (state, action) => ({
  ...state,
  factorStatus: "",
  isLoading: false,
  isError: true,
  errorMessage: oktaErrorMessage(action)
}));

actionMap.set(onFinish(PASSCODE_SUBMIT), (state, action) => ({
  ...state,
  factors: getEffectiveFactors(state.factors, action.data)
  // factorStatus: getFactorStatus([action.data]),
}));

actionMap.set(onFinish(SET_SECURITY_QUESTION), (state, action) => {
  return {
    ...state,
    factors: getEffectiveFactors(state.factors, action.data)
    // factorStatus: getFactorStatus([action.data]),
  };
});

actionMap.set(SKIP_FACTORS, (state, action) => ({
  ...state,
  factorStatus: "skipped"
}));

actionMap.set(onStart(SUBMIT_ANSWER), (state, action) => ({
  ...state,
  isLoading: true,
  isError: false,
  errorMessage: ""
}));
actionMap.set(onFinish(SUBMIT_ANSWER), (state, action) => ({
  ...state,
  isLoading: false,
  isError: false,
  errorMessage: "",
  recoveryStateToken: action.data.stateToken
}));
actionMap.set(onError(SUBMIT_ANSWER), (state, action) => ({
  ...state,
  isLoading: false,
  isError: false
}));

actionMap.set(onStart(FORGOT_PASSWORD), (state, action) => ({
  ...state,
  isLoading: true,
  isError: false,
  errorMessage: ""
}));
actionMap.set(onFinish(FORGOT_PASSWORD), (state, action) => ({
  ...state,
  isLoading: false,
  isError: false,
  recoveryStateToken: action.data.stateToken,
  errorMessage: ""
}));
actionMap.set(onError(FORGOT_PASSWORD), (state, action) => ({
  ...state,
  isLoading: false
}));

actionMap.set(onStart(VERIFY_TOKEN), (state, action) => ({
  ...state,
  isLoading: true,
  isError: false,
  errorMessage: ""
}));
actionMap.set(onFinish(VERIFY_TOKEN), (state, action) => ({
  ...state,
  isLoading: false,
  isError: false,
  errorMessage: "",
  recoveryStateToken: action.data.stateToken,
  recoveryQuestion: get(
    action.data,
    "_embedded.user.recovery_question.question",
    ""
  )
}));
actionMap.set(onError(VERIFY_TOKEN), (state, action) => ({
  ...state,
  isLoading: false,
  isError: true,
  errorMessage: oktaErrorMessage(action)
}));

actionMap.set(onFinish(RECOVERY_PASSCODE_SUBMIT), (state, action) => ({
  ...state,
  isLoading: false,
  isError: false,
  errorMessage: "",
  recoveryStateToken: action.data.stateToken,
  recoveryQuestion: get(
    action.data,
    "_embedded.user.recovery_question.question",
    ""
  )
}));

actionMap.set(onFinish(RESET_PASSWORD), (state, action) => ({
  ...state,
  isLoading: false,
  isError: false,
  authnResponse: action.data
}));

actionMap.set(onStart(GET_QUESTION_STATUS), (state, action) => ({
  ...state,
  isLoading: true
}));

actionMap.set(onFinish(GET_QUESTION_STATUS), (state, action) => ({
  ...state,
  isLoading: false
}));

actionMap.set(onError(GET_QUESTION_STATUS), (state, action) => ({
  ...state,
  isLoading: false
}));

actionMap.set(SESSION_EXPIRED, (state, action) => ({
  ...state,
  isLoading: false,
  isError: true,
  errorMessage: action.message
}));

actionMap.set(onFinish(RESEND_PASSWORD_RECOVERY_CODE), (state, action) => ({
  ...state,
  recoveryStateToken: action.data.stateToken
}));

actionMap.set(REMEMBER_DEVICE, (state, action) => ({
  ...state,
  rememberDevice: action.data
}));

const isAuthSuccess = (action) => get(action.data, "status", "") === "SUCCESS";

const getXOktaRequestId = (action) => {
  let reqId = action.headers.find((n) => n["x-cdk-request-id"]);
  return reqId ? reqId["x-cdk-request-id"] : "";
};

// eslint-disable-next-line import/no-anonymous-default-export
export default (state = initialState, action) => {
  return stateModifier(state, action, actionMap);
};
